<ng-select
  class="dropdown-selector"
  appendTo="body"
  [class.disabled]="!canUpdateUserPermission"
  [(ngModel)]="user.permission"
  [clearable]="false"
  [searchable]="false"
  [disabled]="!canUpdateUserPermission"
  (change)="onUpdatePermission.emit()"
>
  <ng-option *ngFor="let permission of permissionOptions" [value]="permission">
    <span i18n>{{ permission }}</span>
  </ng-option>
</ng-select>
